module.exports = __webpack_public_path__ + "img/how-to-start.37644ec.svg";